const playerPredictionsReducer = (state = [], action) => {
    switch (action.type) {
      case 'FETCH_USER_PUBLIC_PREDICTIONS':
        return action.payload
      default:
        return state
    }
  }
  
  export default playerPredictionsReducer
  